// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__391Hp","insightsList":"newBusinessInsightsMenu_insightsList__3NeO3","active":"newBusinessInsightsMenu_active__1_Fq9"};